<template lang="pug">
    .container.w-96.p-4.border.shadow-sm.bg-white
        template(v-if="!forgot")
            form(@submit.prevent="onLogin($data)")
                text-input(:label="FORMS_LABELS.email" @value="onEmail" class="mb-2")
                text-input(:label="FORMS_LABELS.password" input-type="password" @value="onPassword" class="mb-4")
                regular-button(value="войти" :loading="loggingIn")
            button.mt-4.block.text-sm.text-gray-600.cursor-pointer(type="button" @click="onForgot") Забыли пароль?
        template(v-else)
            form(@submit.prevent="onRecover")
                text-input(:label="FORMS_LABELS.email" :value="recoveryEmail" @value="onRecoveryEmail" class="mb-4")
                regular-button(
                    value="отправить"
                    :loading="recoverySending"
                )
                p.mt-3.text-sm(:class="recoveryIsError ? 'text-red-500' : 'text-gray-700'" v-if="recoveryMessage") {{ recoveryMessage }}
            button.mt-4.block.text-sm.text-gray-600.cursor-pointer(type="button" @click="forgot = false") Вернуться ко входу
</template>

<script>
//Components
import TextInput from '@/components/common/forms/text-input';
import RegularButton from '@/components/common/buttons/regular-button';
//Store
import { AuthorizationNameSpace, AuthorizationActionTypes } from '@/store/authorization/types';
//Config
import { FORMS_LABELS, BUTTONS_VALUES } from '@/configs/names.js'

export default {
    name: "LoginForm",
    components: {
        'text-input': TextInput,
        'regular-button': RegularButton,
    },
    data() {
        return {
            email: '',
            password: '',
            forgot: false,
            recoveryEmail: '',
            recoveryMessage: '',
            recoveryIsError: false,
            recoverySending: false,
            loggingIn: false,
        }
    },
    computed: {
        FORMS_LABELS() {
            return FORMS_LABELS
        },
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
    },
    methods: {
        async onLogin({ email, password }) {
            if (this.loggingIn) {
                return
            }
            this.loggingIn = true
            try {
                await this.$store.dispatch(`${AuthorizationNameSpace}/${AuthorizationActionTypes.Login}`, { email, password })
            } finally {
                this.loggingIn = false
            }
        },
        onEmail(value) {
            this.email = value
        },
        onPassword(value) {
            this.password = value
        },
        onForgot() {
            this.recoveryEmail = this.email
            this.recoveryMessage = ''
            this.recoveryIsError = false
            this.forgot = true
        },
        onRecoveryEmail(value) {
            this.recoveryEmail = value
        },
        async onRecover() {
            if (this.recoverySending) {
                return
            }
            this.recoverySending = true
            this.recoveryMessage = ''
            try {
                const data = await this.$store.dispatch(`${AuthorizationNameSpace}/${AuthorizationActionTypes.RecoverPassword}`, {
                    email: this.recoveryEmail,
                })
                if (!data) {
                    this.recoveryIsError = true
                    this.recoveryMessage = 'Не удалось отправить письмо'
                    return
                }
                if (data.error_message) {
                    this.recoveryIsError = true
                    this.recoveryMessage = data.error_message
                    return
                }
                this.recoveryIsError = false
                this.recoveryMessage = data.message
            } finally {
                this.recoverySending = false
            }
        }
    }
}
</script>